"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.articlePreviewConfigDefault = exports.toggleFavorite = exports.createArticlePreview = exports.ArticlePreview = void 0;
var ArticlePreview = /** @class */ (function () {
    function ArticlePreview(props) {
        this.image = null;
        this.readMinutes = 0;
        this.audioDuration = 0;
        this.processing = false;
        this.id = props.id;
        this.slug = props.slug;
        this.url = props.url;
        this.setImage(props.image_url);
        this.lang = props.lang;
        this.title = props.title;
        this.shortTitle = props.shortTitle;
        this.bibliography = props.bibliography;
        this.topic = props.topic;
        this.audioDuration = props.audioDuration;
        this.readMinutes = props.readMinutes;
        this.favorited = props.favorited;
        this.congress = props.congress;
        this.journal = props.journal;
        this.category = props.category;
        this.organization = props.organization;
    }
    ArticlePreview.prototype.setImage = function (url) {
        if (url === null) {
            this.image = null;
            return;
        }
        this.image = { url: url, loaded: false };
    };
    Object.defineProperty(ArticlePreview.prototype, "listenMinutes", {
        get: function () {
            if (this.audioDuration === 0) {
                return 0;
            }
            if (this.audioDuration > 0 && this.audioDuration < 60) {
                return 1;
            }
            return Math.round(this.audioDuration / 60);
        },
        enumerable: false,
        configurable: true
    });
    return ArticlePreview;
}());
exports.ArticlePreview = ArticlePreview;
function createArticlePreview(rawPreview) {
    return new ArticlePreview({
        id: rawPreview.id,
        slug: rawPreview.slug,
        url: rawPreview.web_url,
        image_url: rawPreview.libraryimage_path,
        lang: rawPreview.lang,
        title: rawPreview.title,
        shortTitle: rawPreview.shorttitle,
        bibliography: rawPreview.bibliography,
        readMinutes: rawPreview.read_minutes,
        audioDuration: rawPreview.audio_duration,
        favorited: rawPreview.favorited === '1',
        category: rawPreview.category,
        congress: rawPreview.congress,
        journal: rawPreview.journal,
        organization: rawPreview.organization,
        topic: rawPreview.topic
    });
}
exports.createArticlePreview = createArticlePreview;
function toggleFavorite(articlePreview, http) {
    return http.get('/articles/' + articlePreview.slug + '/ajax_favorite')
        .then(function (res) {
        if (res.data === 'added') {
            return {
                favorited: true,
            };
        }
        if (res.data === 'removed') {
            return {
                favorited: false,
            };
        }
        throw new Error('Could not toggle favorite.');
    });
}
exports.toggleFavorite = toggleFavorite;
exports.articlePreviewConfigDefault = {
    type: 'vertical',
    enableButtonFavorite: true,
    enableShadow: true,
};
